import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Grid, Typography, Box } from '@mui/material';
import Header from './components/header';
import Footer from './components/footer';
import SEOTags from './common/SEO';
import Logo from './assets/img/NGF-logo.svg';
import AboutImg from './assets/img/common/about-img.jpg'
import AboutBanner from './assets/img/banner/AboutUsBanner.jpg';


const Terms = () => {
    const [videoLoaded, setVideoLoaded] = useState(false);
    const loadVideo = () => {
        setVideoLoaded(true);
    };
    useEffect(() => {
        SEOTags(
            "Terms & Conditions | Figgers Law",
            "THE LAW OFFICE OF NATLIE G. FIGGERS, PLLC, also known as FIGGERS LAW ",
            "Terms & Conditions | Figgers Law"
        );
    }, [])
    return (
        <>

            <Header></Header>
            <div className="about-page-hero" style={{
                backgroundImage: `url(${AboutBanner})`,
                backgroundSize: "cover",
                backgroundPosition: "right",
            }}
            >
                <div className="container">
                    <div className="section-label">THE LAW OFFICE OF NATLIE G. FIGGERS, PLLC</div>
                    <h1>Terms & Conditions
                    </h1>

                </div>
            </div>

            <section className="about privacy" id="about">


                <div className="container about-content" style={{ marginTop: '44px' }}>
                    <p>
                        These Website Terms and Conditions (the "Terms") govern your
                        access to and use of{" "}
                        <a
                            href="https://figgerslaw.com"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://figgerslaw.com
                        </a>
                        , any page or form that links to these Terms, and related online
                        services provided by THE LAW OFFICE OF NATLIE G. FIGGERS, PLLC,
                        also known as FIGGERS LAW (collectively, the "Site"). By using the
                        Site, you agree to these Terms and acknowledge the Privacy Policy.
                        If you do not agree, do not use the Site.
                    </p>

                    <h2 style={{fontSize: '22px'}}>1. Informational Content Only</h2>

                    <p>
                        The Site provides general educational and informational material.
                        It is not legal advice, medical advice, tax advice, financial
                        advice, or a substitute for advice from a qualified professional
                        who has reviewed your specific facts. Laws, deadlines, court
                        rules, and available remedies vary by jurisdiction and may change.
                        You should not act or refrain from acting solely because of
                        information on the Site.
                    </p>

                    <h2 style={{fontSize: '22px'}}>2. No Attorney-Client Relationship or Acceptance of a Matter</h2>

                    <p>
                        Visiting the Site, submitting a form, requesting a consultation,
                        sending an email or text, leaving a voicemail, or receiving an
                        automated response does not by itself create an attorney-client
                        relationship and does not mean that the Firm has accepted your
                        matter. The Firm does not intend to undertake representation
                        unless and until the Firm and the client execute a written
                        engagement agreement or the Firm otherwise clearly agrees in
                        writing to represent the client.
                    </p>

                    <p>
                        Unless the Firm has accepted responsibility in a signed engagement
                        agreement, the Firm is not responsible for any statute of
                        limitation, notice period, filing deadline, court date,
                        contractual deadline, or other time limit. Do not use the Site,
                        email, text messaging, voicemail, or an automated assistant for
                        emergencies or urgent deadlines.
                    </p>

                    <h2 style={{fontSize: '22px'}}>3. Prospective Client Information and Conflicts</h2>

                    <p>
                        Before a preliminary conflict review, provide only the information
                        requested by the Firm and do not send unnecessary confidential
                        documents, legal strategy, medical records, Social Security
                        numbers, financial account information, or other highly sensitive
                        information. The Firm will handle information received from
                        prospective clients in accordance with applicable professional
                        obligations, but use of an ordinary website form, email, or text
                        message does not by itself guarantee that a communication is
                        privileged or establish representation.
                    </p>

                    <p>
                        The Firm may be unable to consider or accept a matter because of a
                        conflict, capacity limitation, subject matter, jurisdiction,
                        timing, or other reason. No duty to decline, investigate, preserve
                        evidence, communicate with another party, or protect a deadline
                        arises unless the Firm agrees otherwise in writing.
                    </p>

                    <h2 style={{fontSize: '22px'}}>4. Jurisdiction and Attorney Advertising</h2>

                    <p>
                        This Site constitutes attorney advertising. The Law Office of
                        Natlie G. Figgers, PLLC, is responsible for its content, and its
                        principal office is located in Coral Springs, Florida. The Site is
                        operated from Florida. The Firm's attorneys practice only where
                        licensed or otherwise permitted by law. Website content is not a
                        representation that the Firm can provide legal services in every
                        jurisdiction. When lawful and appropriate, the Firm may discuss
                        association with or referral to other counsel, subject to client
                        consent and applicable professional rules.
                    </p>

                    <p>
                        Prior results, testimonials, endorsements, descriptions of
                        matters, or statements about experience do not guarantee or
                        predict a similar outcome. Every matter depends on its facts,
                        governing law, evidence, parties, decision-makers, and other
                        circumstances. Contingent-fee representation, when offered,
                        requires a written agreement signed by the client and the Firm and
                        is subject to applicable Florida law, ethical rules, and fee
                        limitations. The availability and terms of a contingent-fee
                        arrangement depend on the nature of the matter.
                    </p>

                    <h2 style={{fontSize: '22px'}}>5. SMS and Text Messaging Terms</h2>

                    <p>
                        By affirmatively opting in, you consent to receive SMS or similar
                        text messages from Figgers Law at the mobile number you provide.
                        We offer two separate SMS programs, and you may choose either,
                        both, or neither:
                    </p>

                    <ol>
                        <li>
                            consultation and matter-related messages, including intake and
                            conflict follow-up, scheduling, appointment reminders, document
                            and electronic-signature requests, requests for information,
                            case or account updates, billing information, deadlines, and
                            security notices; and
                        </li>

                        <li>
                            informational and promotional messages, including legal
                            information, Firm announcements, community events, seminars,
                            review requests, and information about legal services.
                        </li>
                    </ol>

                    <p>
                        Consent to either SMS category is optional. Consent to promotional
                        messages is not a condition of requesting a consultation, hiring
                        the Firm, receiving legal services, or purchasing any property,
                        goods, or services. Promotional messages may be sent using
                        automated technology. Message frequency varies, and recurring
                        messages may be sent. Message and data rates may apply.
                    </p>

                    <p>
                        To opt out, reply STOP to any message. You may also use another
                        reasonable method that clearly communicates your request, including
                        replying CANCEL, END, QUIT, UNSUBSCRIBE, REVOKE, or OPT OUT;
                        calling us at{" "}
                        <a href="tel:+19544510919">(954) 451-0919</a>; or emailing{" "}
                        <a href="mailto:info@figgerslaw.com">
                            info@figgerslaw.com
                        </a>
                        . Reply HELP for assistance. We may send one message confirming
                        the opt-out request. An opt-out may stop automated matter-related
                        texts as well as promotional texts.
                    </p>

                    <p>
                        No mobile information will be shared with third parties or
                        affiliates for marketing or promotional purposes. All disclosure
                        categories in the Privacy Policy exclude text-messaging originator
                        opt-in data and consent; this information will not be shared with
                        third parties, except telecommunications and messaging service
                        providers solely to deliver messages on our behalf, persons you
                        authorize, or when required by law. Those recipients may not use
                        the information for their own marketing or promotional purposes.
                        Please review our Privacy Policy for additional information.
                    </p>

                    <p>
                        You certify that you are the subscriber or customary user of the
                        mobile number provided, or are authorized to consent for that
                        number. You agree to notify us promptly if the number changes, is
                        disconnected, or is reassigned. Wireless carriers do not guarantee
                        delivery and are not responsible for delayed or undelivered
                        messages.
                    </p>

                    <h2 style={{fontSize: '22px'}}>6. Electronic Communications</h2>

                    <p>
                        You may consent to communications by email, telephone, text
                        message, client portal, electronic signature, or other electronic
                        means. Electronic communications can be delayed, misdirected,
                        intercepted, or accessed on shared devices. Keep your contact
                        information and privacy instructions current. Calls or meetings
                        will be recorded or transcribed only after any notice and consent
                        required by applicable law.
                    </p>

                    <h2 style={{fontSize: '22px'}}>7. Privacy Policy</h2>

                    <p>
                        Our Privacy Policy, available at{" "}
                        <a href="/privacy-policy">
                            https://figgerslaw.com/privacy-policy
                        </a>
                        , explains how we collect, use, disclose, retain, and protect
                        personal information and is incorporated into these Terms by
                        reference. If a signed engagement agreement governs an existing
                        attorney-client relationship, that agreement and applicable law
                        control over these Terms as to the representation.
                    </p>

                    <h2 style={{fontSize: '22px'}}>8. Permitted Use</h2>

                    <p>
                        The Firm grants you a limited, revocable, nonexclusive,
                        nontransferable license to access and use the Site for lawful
                        personal or internal business purposes. You may not:
                    </p>

                    <ul>
                        <li>
                            Use the Site for an unlawful, fraudulent, abusive, harassing,
                            defamatory, deceptive, or malicious purpose.
                        </li>

                        <li>
                            Attempt to gain unauthorized access to the Site, accounts,
                            systems, data, or networks, or interfere with security,
                            availability, or operation.
                        </li>

                        <li>
                            Introduce malicious code; scrape, crawl, harvest, or extract data
                            by automated means except as permitted by law and our written
                            authorization; or place an unreasonable load on the Site.
                        </li>

                        <li>
                            Impersonate another person, misrepresent authority, submit
                            information you are not authorized to provide, or violate another
                            person's privacy, publicity, intellectual-property, or
                            contractual rights.
                        </li>

                        <li>
                            Copy, reproduce, modify, distribute, sell, publish, frame,
                            mirror, or create derivative works from Site content except for
                            ordinary personal use or with the Firm's written permission.
                        </li>
                    </ul>

                    <h2 style={{fontSize: '22px'}}>9. Intellectual Property</h2>

                    <p>
                        The Site, its original text, graphics, photographs, videos, logos,
                        trademarks, service marks, design, software, and other content are
                        owned by or licensed to the Firm and are protected by applicable
                        intellectual-property laws. No right or license is granted except
                        the limited permission expressly stated in these Terms. Third-party
                        names and marks belong to their respective owners.
                    </p>

                    <h2 style={{fontSize: '22px'}}>10. User Submissions</h2>

                    <p>
                        You are responsible for the accuracy, legality, and authority of
                        information you submit. You grant the Firm a limited license to
                        receive, store, reproduce, transmit, and use a submission only as
                        reasonably necessary to evaluate your inquiry, provide requested
                        services, operate the Site, comply with law and professional
                        duties, or carry out another purpose disclosed when you submit it.
                        This license does not authorize the Firm to publish confidential
                        legal-matter information for advertising without separate
                        permission.
                    </p>

                    <h2 style={{fontSize: '22px'}}>11. Third-Party Services and Links</h2>

                    <p>
                        The Site may contain links to or integrations with third-party
                        websites and services. They are provided for convenience and do
                        not necessarily imply endorsement. The Firm does not control their
                        content, availability, security, privacy practices, or terms. Your
                        use of a third-party service is governed by that provider's terms.
                    </p>

                    <h2 style={{fontSize: '22px'}}>12. Website Availability and Disclaimer of Warranties</h2>

                    <p>
                        The Firm may modify, suspend, or discontinue any part of the Site
                        without notice. Although we seek to provide useful and accurate
                        information, the Site may contain errors, omissions, outdated
                        information, or technical problems. To the fullest extent
                        permitted by law, the Site is provided on an "as is" and "as
                        available" basis without warranties of any kind, express or
                        implied, including warranties of accuracy, completeness,
                        availability, security, merchantability, fitness for a particular
                        purpose, title, or noninfringement.
                    </p>

                    <p>
                        Nothing in these Terms disclaims or limits any professional duty or
                        liability that cannot lawfully be disclaimed or limited, and
                        nothing in these Terms changes the duties created by a signed
                        engagement agreement.
                    </p>

                    <h2 style={{fontSize: '22px'}}>13. Limitation of Liability</h2>

                    <p>
                        To the fullest extent permitted by law, the Firm and its personnel
                        and service providers will not be liable for indirect, incidental,
                        special, exemplary, punitive, or consequential damages arising
                        solely from use of or inability to use the public Site, including
                        loss of data, opportunity, revenue, or profits. This limitation
                        does not apply to legal services governed by a signed engagement
                        agreement, professional liability that cannot be limited by law,
                        gross negligence, willful misconduct, or any other liability that
                        applicable law does not permit the Firm to exclude or limit.
                    </p>

                    <h2 style={{fontSize: '22px'}}>14. Indemnification for Unlawful Misuse</h2>

                    <p>
                        To the extent permitted by law, you agree to indemnify and hold the
                        Firm and its personnel harmless from third-party claims, losses,
                        or reasonable costs arising from your unlawful misuse of the Site,
                        your infringement of another person's rights, or information you
                        knowingly submit without authority. This section does not apply to
                        an ordinary good-faith request for legal services or to claims that
                        cannot lawfully be subject to indemnification.
                    </p>

                    <h2 style={{fontSize: '22px'}}>15. Governing Law and Venue</h2>

                    <p>
                        These Terms and disputes concerning use of the public Site are
                        governed by Florida law, without regard to conflict-of-law rules.
                        Subject to applicable jurisdictional requirements, any judicial
                        proceeding arising solely from these Terms or use of the public
                        Site must be brought in a state or federal court located in Broward
                        County, Florida. This section does not govern venue, forum, fee
                        disputes, malpractice claims, or other matters controlled by a
                        signed engagement agreement, court rule, statute, or nonwaivable
                        law.
                    </p>

                    <h2 style={{fontSize: '22px'}}>16. Changes, Severability, and Entire Agreement</h2>

                    <p>
                        We may revise these Terms by posting an updated version and
                        changing the effective date. Continued use after the effective
                        date constitutes acceptance to the extent permitted by law. If a
                        provision is held invalid or unenforceable, it will be enforced to
                        the maximum extent permitted and the remaining provisions will
                        continue in effect. Failure to enforce a provision is not a
                        waiver.
                    </p>

                    <p>
                        These Terms and the Privacy Policy constitute the agreement
                        concerning use of the public Site. They do not replace, amend,
                        restrict, or supersede a consultation agreement, engagement
                        agreement, settlement authority, informed-consent form, court
                        order, or other written agreement governing legal services.
                    </p>

                    <h2 style={{fontSize: '22px'}}>17. Contact and Accessibility</h2>

                    <p>
                        Contact us with questions about these Terms, an accessibility
                        concern, or an SMS request:
                    </p>

                 



                    <div className="privacy-contact-box">
                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Firm</div>
                            <div className="privacy-contact-value">
                                THE LAW OFFICE OF NATLIE G. FIGGERS, PLLC
                            </div>
                        </div>

                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Website</div>
                            <div className="privacy-contact-value">
                                <a
                                    href="https://figgerslaw.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    https://figgerslaw.com
                                </a>
                            </div>
                        </div>

                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Email</div>
                            <div className="privacy-contact-value">
                                <a href="mailto:info@figgerslaw.com">
                                    info@figgerslaw.com
                                </a>
                            </div>
                        </div>

                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Telephone</div>
                            <div className="privacy-contact-value">
                                <a href="tel:+19544510919">(954) 451-0919</a>
                                <span className="privacy-contact-or">or</span>
                                <a href="tel:+18556435291">(855) 643-5291</a>
                            </div>
                        </div>

                        <div className="privacy-contact-row">
                            <div className="privacy-contact-label">Mail</div>
                            <div className="privacy-contact-value">
                                10100 West Sample Road, Suite 300,
                                <br />
                                Coral Springs, Florida 33065
                            </div>
                        </div>
                    </div>

                </div>


            </section >
            <Footer></Footer>
        </>

    );
};

export default Terms;
